import { RouterProvider } from 'react-router-dom';
import { router } from './routes';
import DemoModal from '@components/common/DemoModal';

function App() {
    return (
        <>
            <RouterProvider router={router} />
            <DemoModal />
        </>
    );
}

export default App;
